import {
  HelperTooltipWithTranslations,
  LanguageNameSpaces,
  TradeStatus,
  TradeSourceType,
} from "@shared/types";
import { TRADE_STATUS_IN_CANCEL_HELPER_TOOLTIP } from "@shared/common/Tooltips/constants";
import { TradeSource } from "@shared/features/trades/common/types";

export const TRADES_DATA_ALLOCATED_AMOUNT_BTC_HEADER = "allocated_amount_btc";
export const TRADES_DATA_ALLOCATED_AMOUNT_USD_HEADER = "allocated_amount_usd";
export const TRADES_DATA_USD_AMOUNT_CHANGE_HEADER = "usd_amount_change";
export const TRADES_DATA_BTC_AMOUNT_CHANGE_HEADER = "btc_amount_change";
export const OpenTradeStatus = new Set([
  TradeStatus.BUYING_STAGE,
  TradeStatus.SELLING_STAGE,
  TradeStatus.IN_EDIT,
  TradeStatus.IN_CANCEL,
]);
export const ClosedTradeStatus = new Set([
  TradeStatus.FULFILLED,
  TradeStatus.CANCELLED,
  TradeStatus.STOPPED_OUT,
  TradeStatus.PARTIAL_FULFILLED,
  TradeStatus.LIQUIDATED,
  TradeStatus.POSITION_CLOSED,
  TradeStatus.SUBSCRIPTION_ENDED,
  TradeStatus.MARKET_IS_NOT_AVAILABLE,
  TradeStatus.CLIENT_DELETED,
  TradeStatus.INACTIVE,
  TradeStatus.PENDING,
  TradeStatus.EDITED,
]);

export const EDIT_GRID_BOT_TRADE_WARNING = "warnings.grid_bot_edit";
export const EDIT_HEDGING_BOT_TRADE_WARNING = "warnings.hedging_bot_edit";

export const getBotManagedTradeEditWarning = (
  tradeSource?: TradeSourceType | TradeSource
) => {
  if (
    tradeSource === TradeSourceType.GRID_BOT ||
    tradeSource === TradeSource.GRID_BOT
  ) {
    return EDIT_GRID_BOT_TRADE_WARNING;
  }
  if (
    tradeSource === TradeSourceType.HEDGING_BOT ||
    tradeSource === TradeSource.HEDGING_BOT
  ) {
    return EDIT_HEDGING_BOT_TRADE_WARNING;
  }
};

export const BULK_CLOSE_TRADES_MUTATION_KEY = "bulkCloseTrades";

export const TITLE_TO_VALUE_TO_HELPER_TOOLTIP: Record<
  string,
  Record<
    string | number,
    HelperTooltipWithTranslations<LanguageNameSpaces.COMMON>
  >
> = {
  ["Status"]: {
    ["Waiting for cancel verification"]: TRADE_STATUS_IN_CANCEL_HELPER_TOOLTIP,
  },
};

export const GET_TRADES_ARGS_KEY_TO_TRADE_DATA_KEY = {
  exchange: "exchange",
  account_id: "client_id",
  coin: "symbol",
  dca_bot_id: "bot_id",
  signal_id: "signal_id",
};

export const MOBILE_GET_OPEN_TRADES_ARGS = { add_price_graph_data: true };
